import { Link, createFileRoute, redirect } from '@tanstack/react-router'

import { AuthLayout } from '@/features/auth/AuthLayout'
import { RegisterForm } from '@/features/auth/RegisterForm'
import { instanceQueryOptions, meQueryOptions } from '@/features/auth/api'

export const Route = createFileRoute('/register')({
  beforeLoad: async ({ context: { queryClient } }) => {
    const { me } = await queryClient.ensureQueryData(meQueryOptions())
    if (me) throw redirect({ to: '/' })
  },
  loader: ({ context: { queryClient } }) => queryClient.ensureQueryData(instanceQueryOptions()),
  component: RegisterPage,
})

function RegisterPage() {
  const { instance } = Route.useLoaderData()

  // The server enforces this too — this is just an honest door rather than a
  // form that submits into a FORBIDDEN. The first account is always allowed,
  // whatever the policy says, so a fresh instance still gets in.
  const closed = !instance.needsSetup && instance.registrationPolicy !== 'OPEN'

  if (closed) {
    return (
      <AuthLayout
        title="Registration is closed"
        subtitle={
          instance.registrationPolicy === 'INVITE_ONLY'
            ? 'This instance is invite-only. Ask a member for a link — it will bring you straight in.'
            : 'This instance is not accepting new accounts right now.'
        }
      >
        <Link to="/login" className="btn btn-secondary btn-block">
          Back to sign in
        </Link>
      </AuthLayout>
    )
  }

  return (
    <AuthLayout
      title={instance.needsSetup ? 'Claim this instance' : 'Make yourself at home'}
      subtitle={
        instance.needsSetup
          ? 'The first account becomes the instance admin, and gets a Home lounge to start with.'
          : 'Pick a handle and a password. No email needed.'
      }
    >
      <RegisterForm />

      <p className="muted auth-aside">
        Already have an account? <Link to="/login">Sign in</Link>
      </p>
    </AuthLayout>
  )
}
